<template>
  <!-- Contact form-->
  <div class="bg-dark rounded-3 py-5 px-4 px-md-5 mb-5">
    <div class="text-center mb-3">
      <div class="feature text-white rounded-3 mb-3">
        <h1>ACCESO</h1>
        <!---<FontAwesomeIcon :icon="faUser()"/>-->
      </div>
    </div>
    <div class="row gx-5 justify-content-center">
      <div class="col-lg-8 col-xl-6">
        <form id="contactForm" @submit="checkForm">
          <div class="form-floating mb-3">
            <input class="form-control" id="usuario" type="text" placeholder="Usuario"
                   v-model="usuario"/>
            <label for="usuario">Usuario</label>
            <div class="invalid-feedback" v-if="errors.usuario != null">{{ errors.usuario }}</div>
          </div>
          <div class="form-floating mb-3">
            <input class="form-control" id="contrasena" type="password" placeholder="Contraseña"
                   v-model="password"/>
            <label for="contrasena">Contraseña</label>
            <div class="invalid-feedback" v-if="errors.password != null">{{ errors.password }}</div>
          </div>
          <div class="form-floating mb-0 text-white" align="center">
            <span>¿Olvidaste tu contraseña?</span>
          </div>
          <div class="form-floating mb-3 text-white" align="center">
            <span>Reportar con supervisor</span>
          </div>

          <div class="d-grid">
            <button class="btn btn-primary btn-lg" id="submitButton" type="submit">
              ENTRAR
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
//import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {faUser} from "@fortawesome/free-solid-svg-icons";
import moment from 'moment'
import {UserService} from "@/services/UserService";
import {inject} from "vue";

export default {
  name: 'Login-Component',
  components: {
    //FontAwesomeIcon,
  },
  setup() {
    const $localStorageService = inject('$localStorageService');

    return {
      srv_localStorageService: $localStorageService,
      srv_userService: new UserService( inject('$axios'))
    }
  },
  data() {
    return {
      errors: {},
      usuario: null,
      password: null
    }
  },
  created() {
    this.moment = moment;
  },
  async mounted() {
    this.srv_localStorageService.destroy();
  },
  methods: {
    faUser() {
      return faUser
    },
    async checkForm(e) {
      e.preventDefault();

      this.errors = {
        hasErrors: false,
        usuario: null,
        password: null
      };

      if (!this.usuario) {
        this.errors.hasErrors = true;
        this.errors.usuario = 'El usuario es obligatorio.';
      }
      if (!this.password) {
        this.errors.hasErrors = true;
        this.errors.password = 'El password es obligatorio.';
      }

      if (!this.errors.hasErrors) {
        let load = this.$loading.show({
          container: this.$refs.formContainer,//puede ponerse null
          canCancel: true,
          onCancel: this.onCancelLoader,
        });

        await this.srv_userService.login(this.usuario, this.password).then((response) => {
          this.srv_localStorageService.start(response.access, response.refresh);
        }).catch((error) => {
          load.hide();
          this.$swal(error.message);
          console.error(error)
        });

        if (this.srv_localStorageService.isAuth()) {
          await this.srv_userService.me().then((response) => {
            this.srv_localStorageService.setAuthorities(response.autorities);
            this.srv_localStorageService.setNumEmpleado(response.numEmpleado);
            this.srv_localStorageService.setIdUsuario(response.idUsuario);
            this.srv_localStorageService.setNombreCompleto(response.nombreCompleto);
            this.srv_localStorageService.setUsuario(response.nombreUsuario);

            this.$router.push({ name: 'perfil'}).then(() => {
              // this.$router.go(0);
            });


          }).catch(() => {
            this.srv_localStorageService.destroy();
            load.hide();
            this.$swal.fire({
              icon: "error",
              text:'Credenciales incorrectas'
            });


          }).finally(()=>load.hide());
        }

      }
    }
  },
  filters: {

  }
};
</script>

<style scoped>

</style>
